import React from "react";
import { Redirect } from "react-router-dom";

// The promotions screen now edits promotions in a dialog on the list
// page itself (see shopAdminViews/promotions/Promotions.js), so this
// route is kept only so old links and bookmarks to
// /shopAdmin/editPromotion/:id still land somewhere useful — it opens
// the edit dialog for that promotion.
const ShopEditPromotion = (props) => (
  <Redirect to={`/shopAdmin/promotions?edit=${props.match.params.id}`} />
);

export default ShopEditPromotion;
